import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
var ReportConst = require('components/Reports/Const');
var viewActions = require ('store/view.actions');
var tutorsService = require ('../api');
var coursesService = require ('../../courses/api');
var Utils = require ('Utils') ;


export const downloadReport =  async ( token, calendarID, courseID, toolID, title ) => {
    viewActions.notification({message:'El documento ya se esta generando, luego de unos segundos iniciará la descarga.',
                title:'Descarga',type:'success'});
    

    const notas = await tutorsService.getCourseNotebookTool( token, courseID, toolID );
    const course = await coursesService.getSchoolCourse ( token, courseID, calendarID);

    let reportContent = course.students.map( (student ) => {
        let content =  [
            {text: title, style: 'header'},
            {text: 'Curso: ' + course.name, style: 'subheader'} ,
            {text: 'Alumno: ' + Utils.capitalize(student.name + " " + student.last_name), style: 'subheader'} 
        
        ];

        let studentCalifs = notas.filter( nota => nota.persona_id === student.persona_id);

        let calif =  [
            [ {text: 'MATERIA', color: 'white', fillColor: '#101010',  bold: true},
              {text: 'VALORACIÓN DE AVANCE', color: 'white', fillColor: '#101010', bold: true }]
            ] ;

       


        studentCalifs.map( cal => {
            calif.push( [cal.subject_long_name, cal.comments] );
         });


        content.push(
            {
                style: 'tableBody',
                table: {
                    body: calif
                }
            }) ;

        content.push(
            {
                margin: [0, 80, 0, 0],
                table: {
                    widths: [ '*', 10, '*', 10, '*' ],
                    body: [
                        [
                            {text:'', border: [false, true,false, false ]  },
                            {text:'', border: [false ]  },
                            {text:'', border: [false, true,false, false ]  },
                            {text:'', border: [false ]  },
                            {text:'', border: [false, true,false, false ]  }
                        ],
                        [
                            {text:'Director del establecimiento', border: [false ] , alignment: 'center'   },
                            {text:'', border: [false]  },
                            {text:'Sello del Establecimiento', border: [false ], alignment: 'center'   },
                            {text:'', border: [false]  },
                            {text:'Inspector del Area',	border: [false ] , alignment: 'center' }
                        ],
                    ]
                },
                pageBreak: 'after'
            }
        );


        // content.push([ReportConst.signatures])
        return content ;

    })

    const {vfs} = vfsFonts.pdfMake;
    pdfMake.vfs = vfs;
    const documentDefinition = {
      info: {
        title: title + ' - ' + course.name
      },        
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [40, 70, 40, 60],

      header: ReportConst.header,
      styles: ReportConst.styles,
      content: reportContent,
    //   content: [
    //     { text: 'Parte diario de asistencias - Turno ' + 
    //           Const.getObjectByValue(Const.SCHOOL_SHIFTS,this.state.currentShift).label
    //     + '  ' + this.state.formattedCurrentDate , style: 'header' },
    //     this.prepareContent()
    //   ],
      footer: ReportConst.footer,
      // styles: json.styles
    } ;
    
    pdfMake.createPdf(documentDefinition).open();
  }